import { render, staticRenderFns } from "./c-row.vue?vue&type=template&id=d3581504&scoped=true"
import script from "./c-row.vue?vue&type=script&setup=true&lang=js"
export * from "./c-row.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-row.vue?vue&type=style&index=0&id=d3581504&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3581504",
  null
  
)

export default component.exports